import { useContext } from 'react'
import SearchParamsContext from '../contexts/search-params-context'
import type { SearchParamsContextValue } from '../contexts/search-params-context'

const useSearchParamsHelper = (): SearchParamsContextValue => useContext(SearchParamsContext)

export default useSearchParamsHelper
